// extracted by mini-css-extract-plugin
export default {"container":"StockInventoryPopup_container__GaHM1"};